<template>
    <div class="main-layout__container">
        <div class="content__header content__header--one-item-per-line">
            <div class="content-header__back">
                <UIBackButton
                    :text="'К списку дилеров'"
                    :to="router.resolve({ name: 'HandbookDealers' }).href"
                />
            </div>

            <div class="content-header__title">Добавление дилера</div>

            <div class="content-header__background content-header__background--add-edit-page"></div>
        </div>

        <div class="content__body">
            <div class="form__content">
                <div class="form__fields">
                    <UIBrandImageableRadio
                        v-model="formBrand"
                        :error-message="brandErrors.join() ?? ''"
                    />

                    <UIInput
                        id="dealerName"
                        v-model="form.name"
                        label="Название дилера*"
                        :error-message="errors?.name?.join() ?? ''"
                    />

                    <div class="form__field-group">
                        <UIInput
                            id="dealerCode"
                            v-model="form.sap_code"
                            label="Код дилера*"
                            :error-message="errors?.sap_code?.join() ?? ''"
                        />

                        <UISelect
                            id="holding"
                            v-model="form.holding_id"
                            :options="holdingOptions"
                            label="Холдинг"
                            :error-message="errors?.holding_id?.join() ?? ''"
                            searchable
                        />

                        <UISelect
                            id="city"
                            v-model="form.city_id"
                            :options="cityOptions"
                            label="Город*"
                            :error-message="errors?.city_id?.join() ?? ''"
                            searchable
                        />
                    </div>

                    <div class="form__field-group">
                        <UIInput
                            id="site"
                            v-model="form.site"
                            label="Сайт"
                            :error-message="errors?.site?.join() ?? ''"
                        />

                        <UIInput
                            id="phone"
                            v-model="form.phone"
                            label="Телефон"
                            :error-message="errors?.phone?.join() ?? ''"
                        />

                        <UIInput
                            id="email"
                            v-model="form.email"
                            label="Email"
                            :error-message="errors?.email?.join() ?? ''"
                        />
                    </div>

                    <div class="form__field-group">
                        <UIToggle
                            v-model="formIsCertified"
                            label="Сертифицированный дилер"
                            :error-message="errors?.is_certified?.join() ?? ''"
                        />
                    </div>
                </div>

                <div class="form__fields">
                    <div class="form__subtitle">Юридические данные</div>

                    <UIInput
                        id="legalName"
                        v-model="form.legal_name"
                        label="Название юр.лица*"
                        :error-message="errors?.legal_name?.join() ?? ''"
                    />

                    <div class="form__field-group">
                        <UIInput
                            id="inn"
                            v-model="form.inn"
                            label="ИНН*"
                            :error-message="errors?.inn?.join() ?? ''"
                        />

                        <UIInput
                            id="kpp"
                            v-model="form.kpp"
                            label="КПП*"
                            :error-message="errors?.kpp?.join() ?? ''"
                        />

                        <UIInput
                            id="ogrn"
                            v-model="form.ogrn"
                            label="ОГРН*"
                            :error-message="errors?.ogrn?.join() ?? ''"
                        />
                    </div>

                    <UIInput
                        id="signPosition"
                        v-model="form.signer_position"
                        label="Должность подписанта*"
                        :error-message="errors?.signer_position?.join() ?? ''"
                    />

                    <UIInput
                        id="signName"
                        v-model="form.signer_fio"
                        label="ФИО подписанта*"
                        :error-message="errors?.signer_fio?.join() ?? ''"
                    />

                    <UIInput
                        id="rpDetails"
                        v-model="form.signatory_position_and_name"
                        label="Должность и ФИО подписанта (в РП)*"
                        :error-message="errors?.signatory_position_and_name?.join() ?? ''"
                    />

                    <div class="form__field-group">
                        <UIInput
                            id="basedOn"
                            v-model="form.signer_basis"
                            label="На основании (в РП)*"
                            :error-message="errors?.signer_basis?.join() ?? ''"
                        />

                        <UIInput
                            id="contract_number"
                            v-model="form.contract_number"
                            label="Номер договора*"
                            :error-message="errors?.contract_number?.join() ?? ''"
                        />

                        <UIDatePicker
                            id="contract_date"
                            v-model="form.contract_date"
                            label="Дата договора*"
                            :options="{ enableTime: false, dateFormat: 'd.m.Y' }"
                            :error-message="errors?.contract_date?.join() ?? ''"
                        />
                    </div>

                    <UIInput
                        id="legalAddress"
                        v-model="form.address"
                        label="Юридический адрес*"
                        :error-message="errors?.address?.join() ?? ''"
                    />
                </div>

                <div class="form__fields">
                    <div class="form__subtitle">Банковские реквизиты</div>

                    <div class="form__field-group">
                        <UIInput
                            id="account"
                            v-model="form.bank_account"
                            label="Расчетный счет*"
                            :error-message="errors?.bank_account?.join() ?? ''"
                        />

                        <UIInput
                            id="corrAccount"
                            v-model="form.correspondent_account"
                            label="Корр. Счет*"
                            :error-message="errors?.correspondent_account?.join() ?? ''"
                        />

                        <UIInput
                            id="bic"
                            v-model="form.bank_identification_code"
                            label="БИК*"
                            :error-message="errors?.bank_identification_code?.join() ?? ''"
                        />
                    </div>

                    <UIInput
                        id="bankName"
                        v-model="form.bank_name"
                        label="Название банка*"
                        :error-message="errors?.bank_name?.join() ?? ''"
                    />
                </div>
            </div>
        </div>

        <div class="content__footer">
            <div class="form__actions">
                <UISimpleButton
                    button-type="outlined"
                    @clicked="goToDealersPage"
                >
                    Выйти без сохранения
                </UISimpleButton>

                <UISimpleButton
                    :loading="saveLoading"
                    @clicked="saveDealer"
                >
                    Сохранить
                </UISimpleButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, onMounted, ref, watch } from 'vue';
    import { useRouter } from 'vue-router';

    import { SelectOption } from '@/types/form.type.ts';
    import { City } from '@/types/city.type.ts';
    import {
        DealerBrand,
        DealerCreateForm,
        DealerCreateFormErrors,
    } from '@/types/dealer.type.ts';
    import { Holding } from '@/types/holding.type.ts';

    import useCityRepository from '@/repositories/city/useCityRepository.ts';
    import useDealerRepository from '@/repositories/dealer/useDealerRepository.ts';
    import useHoldingRepository from '@/repositories/holding/useHoldingRepository.ts';
    import useNotifications from '@/utils/useNotifications.ts';
    import useUnsavedDataWarning from '@/plugins/useUnsavedDataWarning.ts';

    import { formatToUTC } from '@/utils/DateTimeFormatter.ts';

    import UIBackButton from '@/components/ui/UIBackButton/UIBackButton.vue';
    import UIBrandImageableRadio from '@/components/ui/UIBrandImageableRadio/UIBrandImageableRadio.vue';
    import UIDatePicker from '@/components/ui/UIDatePicker/UIDatePicker.vue';
    import UIInput from '@/components/ui/UIInput/UIInput.vue';
    import UISelect from '@/components/ui/UISelect/UISelect.vue';
    import UISimpleButton from '@/components/ui/UISimpleButton/UISimpleButton.vue';
    import UIToggle from '@/components/ui/UIToggle/UIToggle.vue';

    const router = useRouter();
    const { createDealer, getDealerBrands } = useDealerRepository();
    const { getAllActiveHoldings } = useHoldingRepository();
    const { getAllCities } = useCityRepository();
    const { showSuccess } = useNotifications();
    const { setDirty } = useUnsavedDataWarning();

    const form = ref<DealerCreateForm>({
        name: '',
        sap_code: '',
        holding_id: undefined,
        city_id: undefined,
        site: undefined,
        phone: undefined,
        email: undefined,
        is_certified: 0,
        is_hyundai_dealer: 0,
        is_genesis_dealer: 0,

        legal_name: '',
        inn: '',
        kpp: '',
        ogrn: '',
        signer_position: '',
        signer_fio: '',
        signatory_position_and_name: '',
        signer_basis: '',
        address: '',
        bank_account: '',
        correspondent_account: '',
        bank_identification_code: '',
        bank_name: '',
        contract_number: '',
        contract_date: '',
    });

    const brandOptions = ref<SelectOption[]>([]);
    const holdingOptions = ref<SelectOption[]>([]);
    const cityOptions = ref<SelectOption[]>([]);

    const errors = ref<DealerCreateFormErrors | null>(null);
    const saveLoading = ref<boolean>(false);

    const formBrand = computed<string | undefined>({
        get() {
            if (form.value.is_hyundai_dealer === 1) {
                return 'hyundai';
            }

            if (form.value.is_genesis_dealer === 1) {
                return 'genesis';
            }

            return undefined;
        },
        set(brandValue: string | undefined) {
            form.value.is_hyundai_dealer = 0;
            form.value.is_genesis_dealer = 0;

            if (brandValue === 'hyundai') {
                form.value.is_hyundai_dealer = 1;
            }
            else if (brandValue === 'genesis') {
                form.value.is_genesis_dealer = 1;
            }
        },
    });

    const formIsCertified = computed<boolean>({
        get() {
            return form.value.is_certified === 1;
        },
        set(isCertifiedValue: boolean) {
            if (isCertifiedValue) {
                form.value.is_certified = 1;
            }
            else {
                form.value.is_certified = 0;
            }
        },
    });

    const brandErrors = computed((): string[] => {
        return (errors.value?.is_hyundai_dealer ?? [])
            .concat(errors.value?.is_genesis_dealer ?? []);
    });

    watch(form, () => {
        setDirty(true);
    }, { deep: true });

    function saveDealer(): void {
        saveLoading.value = true;
        errors.value = null;

        const createdDealer = mapCreatedDealerFromForm();

        if (createdDealer) {
            createDealer(createdDealer)
                .then(() => {
                    setDirty(false);

                    showSuccess({
                        title: 'Дилер добавлен',
                    });

                    goToDealersPage();
                })
                .catch((createdErrors: DealerCreateFormErrors) => {
                    errors.value = createdErrors;
                })
                .finally(() => {
                    saveLoading.value = false;
                });
        }
        else {
            saveLoading.value = false;
        }
    }

    function validatedForm(): boolean {
        if (form.value.city_id === undefined) {
            errors.value = {
                city_id: ['Поле обязательно для заполнения'],
            };

            return false;
        }

        return true;
    }

    function mapCreatedDealerFromForm(): DealerCreateForm | undefined {
        if (!validatedForm()) {
            return;
        }

        const dealerCreateForm: DealerCreateForm = {
            sap_code: form.value.sap_code,
            city_id: form.value.city_id,
            name: form.value.name,
            is_certified: form.value.is_certified,
            is_hyundai_dealer: form.value.is_hyundai_dealer,
            is_genesis_dealer: form.value.is_genesis_dealer,
            phone: form.value.phone,
            email: form.value.email,
            site: form.value.site,

            legal_name: form.value.legal_name,
            address: form.value.address,
            inn: form.value.inn,
            kpp: form.value.kpp,
            ogrn: form.value.ogrn,
            bank_account: form.value.bank_account,
            bank_name: form.value.bank_name,
            correspondent_account: form.value.correspondent_account,
            bank_identification_code: form.value.bank_identification_code,
            signer_fio: form.value.signer_fio,
            signer_position: form.value.signer_position,
            signer_basis: form.value.signer_basis,
            signatory_position_and_name: form.value.signatory_position_and_name,
            contract_number: form.value.contract_number,
            contract_date: form.value.contract_date !== undefined && form.value.contract_date.length > 0 ? formatToUTC(form.value.contract_date, {
                fromFormat: 'dd.LL.yyyy',
                toFormat: 'yyyy-LL-dd',
                withTime: false,
            }): '',
        };

        if (form.value.holding_id !== undefined) {
            dealerCreateForm.holding_id = form.value.holding_id;
        }

        return dealerCreateForm;
    }

    function goToDealersPage(): void {
        router.push({ name: 'HandbookDealers' });
    }

    function fetchFormOptions(): void {
        getDealerBrands().then((brands: DealerBrand[]) => {
            const options: SelectOption[] = [];

            brands.forEach((brand: DealerBrand) => {
                options.push({
                    label: brand.name,
                    value: brand.code,
                });
            });

            brandOptions.value = options;
        });

        getAllActiveHoldings().then((holdings: Holding[]) => {
            const options: SelectOption[] = [];

            holdings.forEach((holding: Holding) => {
                options.push({
                    label: holding.name,
                    value: holding.id,
                });
            });

            holdingOptions.value = options;
        });

        getAllCities().then((cities: City[]) => {
            const options: SelectOption[] = [];

            cities.forEach((city: City) => {
                options.push({
                    label: city.name,
                    value: city.id,
                });
            });

            cityOptions.value = options;
        });
    }

    onMounted(() => {
        fetchFormOptions();
    });
</script>
